const isElementNode = (node) => node?.nodeType === 1;

const containsIframeWithAswiftId = (element) => {
  if (!element || typeof element.querySelector !== 'function') {
    return false;
  }

  return element.querySelector('iframe[id*="aswift"]') !== null;
};

const hasVignetteHeuristicMatch = (element) => {
  if (!element) {
    return false;
  }

  const id = String(element.id || '').toLowerCase();
  if (id.includes('google-vignette')) {
    return true;
  }

  if (element.classList?.contains('google-vignette-container')) {
    return true;
  }

  if (String(element.tagName || '').toLowerCase() === 'iframe') {
    const iframeId = String(element.id || '').toLowerCase();
    if (iframeId.includes('aswift')) {
      return true;
    }
  }

  return containsIframeWithAswiftId(element);
};

export const isLikelyVignetteNode = (node) => isElementNode(node) && hasVignetteHeuristicMatch(node);
